import { FC, ReactNode } from 'react'

import Box from '@mui/material/Box'
import { BEIGE_300, BEIGE_400, GRAY_900 } from 'constants/styling/theme'

interface Props {
  children: ReactNode
}

/**
 * Beige comment block for displaying instructions or notes.
 * @example
 * <DetailCommentBlock>{shootingInstructions}</DetailCommentBlock>
 */
export const DetailCommentBlock: FC<Props> = ({ children }) => (
  <Box
    fontSize="1.4rem"
    fontWeight={400}
    color={GRAY_900}
    padding="1rem"
    borderRadius=".8rem"
    bgcolor={BEIGE_300}
    sx={{ border: `1px solid ${BEIGE_400}`, 'overflow-wrap': 'break-word' }}
  >
    {children}
  </Box>
)
